import React from "react";
import PipelineDetails, {
    proposal,
    listing,
    underContract,
    closed,
} from "../PipelineDetails/PipelineDetails";
import {getData} from "../../requests/CRUD";
import {executeQuery} from "../../requests/executeQuery";
import {STRIVE_BUCKETS_DETAILS, WEBSITE_PACKAGE_DOWNLOADS} from "../../consts/queries";
import {formatName} from "../../utils";
import order from "../AgentPipelineDetails/order";
import {TEAM} from "../../consts/tables";
import moment from "moment";

export default class BucketsDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {                
                [proposal]: {
                    name: 'Proposals',
                    data: [],
                    total: {},
                },
                [listing]: {
                    name: 'Listings - YTD',
                    data: [],
                    total: {},
                    message: ''
                },
                [underContract]: {
                    name: 'In Neg/Under Contract',
                    data: [],
                    total: {},
                    message: ''
                },
                [closed]: {
                    name: 'Closed - YTD',
                    data: [],
                    total: {},
                    message: ''
                },
            },
            agentName: '',
            currentProposalCount: 0,
            loading: true,
            componentName: 'bucketDetails'
        };
    }

    static dedupePropertiesById(properties) {
        const seen = new Set();
        return properties.filter(property => {
            const propertyId = property.ARCIMEDES_ROW_ID;
            if (seen.has(propertyId)) {
                return false;
            }
            seen.add(propertyId);
            return true;
        });
    }

    buildTables(res, currentProposalCount, goalValues) {
        const tables = {...this.state.tables};
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        const proposalData = BucketsDetails.dedupePropertiesById(res[1].data);
        tables[proposal] = BucketsDetails.buildTable(proposal, tables[proposal], proposalData, "", id);
        if (goalValues) {
            tables[proposal].goalValue = goalValues.proposal;
            tables[listing].goalValue = goalValues.listing;
            tables[underContract].goalValue = goalValues.underContract;
            tables[closed].goalValue = goalValues.closed;
        }
        tables[listing] = BucketsDetails.buildTable(listing, tables[listing], res[2].data, "", id);
        tables[underContract] = BucketsDetails.buildTable(underContract, tables[underContract], res[3].data, "", id);
        tables[closed] = BucketsDetails.buildTable(closed, tables[closed], res[4].data, "", id);
        this.setState({tables, currentProposalCount});
    }

    static createOptions({id, status = 'NOMATCH', proposals = 0, listings = 0, orderBy}) {
        return {
            param: {
                AGENT_ID: id,
                STATUS: status,
                PROPOSALS: proposals,
                LISTINGS: listings,
            },
            order: order(orderBy),
        };
    }
    
    fetch(id,emailId) {
        if(id && typeof(id) !== 'string'){
            id = id.toString();
        }
        const currentProposalOptions = BucketsDetails.createOptions({
            id: id,
            proposals: 2,
            orderBy: 'PROPOSAL_DATE.desc'
        });
        const proposalOptions = BucketsDetails.createOptions({
            id: id,
            proposals: 1,
            orderBy: 'PROPOSAL_DATE.desc'
        });
        const listingOptions = BucketsDetails.createOptions({
            id: id,
            listings: 1,
            orderBy: ['STATUS.asc', 'LISTING_DATE.asc']
        });
        const ucOptions = BucketsDetails.createOptions({
            id: id,
            status: underContract,
            orderBy: 'STATUS.asc',
        });
        const closedOptions = BucketsDetails.createOptions({
            id: id,
            status: closed,
            orderBy: 'CLOSE_OF_ESCROW.asc'
        });       
        const requests = [
            executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: currentProposalOptions}),
            executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: proposalOptions}),
            executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: listingOptions}),
            executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: ucOptions}),
            executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: closedOptions}),
            executeQuery({queryName: WEBSITE_PACKAGE_DOWNLOADS}),
        ];
        let agentPhone = '';
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
 
        const options = {
            column: [
                'ON_PHONES',
            ],
            filter: [{
                'text': id,
                'code': 'ARCIMEDES_ROW_ID',
                'type': 'exact',
            }],
        };
        requests.push(getData({tableCode: TEAM, options}));
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            requests.push(getData({tableCode: TEAM, options}));
        }

        Promise.all(requests).then(async (res) => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data) &&
                res[3] && res[3].success && Array.isArray(res[3].data) &&
                res[4] && res[4].success && Array.isArray(res[4].data) &&
                res[6] && res[6].success && Array.isArray(res[6].data) &&
                (!res[7] || res[7] && res[7].success && Array.isArray(res[7].data))) {

                const downloadMap = {};
                if (res[5] && res[5].success && Array.isArray(res[5].data)) {
                    res[5].data.forEach(row => {
                        downloadMap[row.PROPERTY_ID] = parseInt(row.TOTAL_DOWNLOADS || 0);
                    });
                }
                for (let i = 1; i < 5; i++) {
                    res[i].data.forEach(property => {
                        property.WEBSITE_DOWNLOADS = downloadMap[property.ARCIMEDES_ROW_ID] || 0;
                    });
                }

                const currentProposalCount = BucketsDetails.dedupePropertiesById(res[0].data).length;

                let goalValues = null;
                if (res[6] && res[6].data && res[6].data[0]) {
                    agentPhone = res[6].data[0].ON_PHONES;
                    if (agentPhone) {
                        goalValues = BucketsDetails.calculateDateRange(agentPhone);
                    }
                }

                if (res[7] && res[7].data && res[7].data[0]) {
                    agentName = formatName(res[7].data[0]);
                }

                this.setState({agentName}, () => this.buildTables(res, currentProposalCount, goalValues));
            }
            this.setState({loading: false});
        }).catch(() => {
            this.setState({loading: false});
        })
    }

    static calculateDateRange(date) {
        const givenDate = moment(date, 'YYYY-MM-DD');
        const today = moment();
        const diffInYrs = today.diff(givenDate, 'years', true);
        if (diffInYrs <= 1.5) {
            return {proposal: 4, listing: 3, underContract: 2, closed: 4};
        }
        if (diffInYrs > 1.5 && diffInYrs <= 3) {
            return {proposal: 4, listing: 6, underContract: 4, closed: 8};
        }
        return {proposal: 4, listing: 10, underContract: 5, closed: 12};
    }

    render() {
        const { tables, agentName, loading, grossType, currentProposalCount } = this.state;
        const { withoutAgentName, isAgentPipeline, location: {pathname} } = this.props;
        const transactionType = pathname.split("/")[pathname.split("/").length -1];
        const isClosedOrProcurred = pathname.match(/(paid|procured)/);

        return (
            <div className='agent-details-container'>
                {
                    (withoutAgentName || isClosedOrProcurred) ?
                        null
                        :<div>
                            {this.checkIfHscAgent(agentName) ? (
                                 <h3>Hot List</h3> 
                            ) : null}
                           
                            <div className='agent-details'>                            
                                <h4 className='agent-name-label'>Name:</h4>
                                <h4 className='agent-name'>{agentName}</h4>
                            </div>
                        </div>
                }
                <div className="chartgrid" style={{ display: 'flex' }}>
                    {
                        Object.keys(tables).map(key => {
                            const chartTable = key === proposal
                                ? {...tables[key], currentCount: currentProposalCount}
                                : tables[key];
                            return tables[key].name !== 'Closed - Historical' && tables[key].name !== 'Hot List' && (
                                <div key={key} style={{ width: '100%' }}>
                                    {PipelineDetails.renderChart(key, chartTable, loading, isAgentPipeline, grossType, 'bucketDetails')}
                                </div>
                            );
                        })
                    }
                </div>
                {
                    Object.keys(tables).map(key => {
                        return <React.Fragment key={key}>{this.renderTable(key, PipelineDetails.getCurrentYearData(tables[key], key, tables[key].name, 'bucketDetails'), loading, isAgentPipeline, grossType, this.state, this.onSubmit, transactionType, this.props)}</React.Fragment>
                    })
                }
            </div>
        );
    }

    componentDidMount() {
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        const emailId = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.userData.email :
            (this.props.id ? this.props.id : this.props.userData.email);
        if (id) {
            this.fetch(id,emailId);
            return;
        }
        this.setState({loading: false});
    }
}
